export default "__VITE_PUBLIC_ASSET__41806a88__"